import "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
const closeButton = "_closeButton_1rypo_1";
const style0 = {
  closeButton
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "CloseButton",
  inheritAttrs: true
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...createTestIdProp()
  },
  emits: ["close"],
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const { formatTestId } = setupTestId(props);
    return { __sfc: true, createTestIdProp, setupTestId, props, t, formatTestId, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("button", { class: _vm.$style.closeButton, attrs: { "data-testid": _setup.formatTestId("tooltipCloseButton"), "title": _setup.t("ds.xTooltip.actions.close") }, on: { "click": function($event) {
    return _vm.$emit("close");
  } } }, [_c(_setup.XIcon, { attrs: { "icon": "close", "size": "lg" } })], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const CloseButton = __component__.exports;
export {
  CloseButton as default
};
